import styled from '@emotion/styled';
import { TextStyle } from 'styles/variables/mixins';
import { Colors } from 'styles/variables/colors';

type ToggleProps = {
    unsetWidth?: boolean;
    mobile?: boolean;
};

export const HeaderMainSection = styled.div<ToggleProps>`
    ${TextStyle({ fontSize: '15px', fontWeight: '400' })}
    display: flex;
    justify-content: space-between;
    min-width: ${(props) => (props?.unsetWidth ? '' : '70%')};
    white-space: nowrap;
`;

export const Title = styled.h1`
    margin: 0 1rem 0 0;
    display: flex;
    gap: 0.8rem;
    width: 100%;
    font-size: 22px;
    line-height: 1.2;
    font-weight: 700;
`;

export const ChatWithBackOfficeContainer = styled.div<ToggleProps>`
    ${TextStyle({ fontSize: '15px', fontWeight: '400' })}
    display: flex;
    flex-direction: ${(props) => (props.mobile ? 'column-reverse' : 'row')};
    align-items: ${(props) => (props.mobile ? 'flex-start' : 'stretch')};
    justify-content: space-between;
    min-width: 70%;
    white-space: nowrap;
    padding: ${(props) => (props.mobile ? '0px' : '0 1.5rem 0 1.5rem')};
`;

export const ChatLabel = styled.div<ToggleProps>`
    ${TextStyle({ fontSize: '16px', fontWeight: '700', color: Colors.gray })};
    background-color: ${(props) => (props.mobile ? '#F3F1FF' : '#f8f8f8')};
    border-radius: 3px;
    height: 36px;
    padding: 0 12px;
    display: flex;
    align-items: center;
    line-height: 1;
    white-space: nowrap;
    letter-spacing: -0.5px;
    width: ${(props) => (props.mobile ? '100%' : '')};
    border: ${(props) => (props.mobile ? '2px solid #c0c0c0' : '')};
    border-radius: ${(props) => (props.mobile ? '6px' : '3px')};
`;

export const Name = styled.span`
    ${TextStyle({ fontSize: '16px', fontWeight: '700', color: Colors.blue })};
    background-color: #f8f8f8;
    border-radius: 3px;
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    padding-left: 6px;
    letter-spacing: -0.5px;
    max-width: 200px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
`;

export const ToggleButtonGroup = styled.div`
    display: inline-flex;
    padding: 4px;
    border-radius: 999px;
    border: 1px solid #d9d4e8;
    background: #f6f2ff;
    box-shadow: 0 2px 8px rgba(38, 16, 78, 0.08);
    gap: 4px;
    align-self: center;
`;

export const ToggleOptionHitArea = styled.span`
    display: inline-flex;
`;

export const ToggleOption = styled.button<{ active: boolean }>`
    border: none;
    outline: none;
    border-radius: 999px;
    padding: 8px 16px;
    font-weight: 700;
    font-size: 13px;
    white-space: nowrap;
    cursor: pointer;
    transition: all 0.2s ease;
    background: ${(props) => (props.active ? '#5a2ea6' : 'transparent')};
    color: ${(props) => (props.active ? '#ffffff' : '#5a2ea6')};

    &:disabled {
        cursor: not-allowed;
        background: ${(props) => (props.active ? '#c5bdd4' : 'transparent')};
        color: #9a93ab;
        opacity: 0.7;
    }
`;
